import { useCallback, useEffect, useRef, useState } from "react";
import { useField } from "@unform/core";
import { formatInputValue } from "../../../Utils/formatInputValue";
import { convertToCents } from "../../../Utils/formatters";

const QUICK_AMOUNTS = [
  { key: 1, label: "+ R$ 1" },
  { key: 10, label: "+ R$ 10" },
  { key: 50, label: "+ R$ 50" },
  { key: 100, label: "+ R$ 100" },
  { key: 0, label: "Limpar" },
];

export const PixTransferAmountInput = ({ onAmountChange }) => {
  const { fieldName, registerField, error, clearError } = useField("value");
  const [amount, setAmount] = useState("");
  const amountRef = useRef("");
  const onAmountChangeRef = useRef(onAmountChange);

  useEffect(() => {
    onAmountChangeRef.current = onAmountChange;
  }, [onAmountChange]);

  useEffect(() => {
    amountRef.current = amount;
    onAmountChangeRef.current?.(amount);
  }, [amount]);

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => amountRef.current,
      setValue: (_, value) => {
        setAmount(formatInputValue(String(value ?? "")));
      },
      clearValue: () => setAmount(""),
    });
  }, [fieldName, registerField]);

  const handleChange = useCallback(
    (e) => {
      clearError();
      setAmount(formatInputValue(e.target.value));
    },
    [clearError]
  );

  const handleQuickAdd = useCallback(
    (key) => {
      clearError();

      if (key === 0) {
        setAmount("");
        return;
      }

      const currentCents = convertToCents(amount || "0");
      const nextCents = currentCents + convertToCents(String(key));
      setAmount(formatInputValue(String(nextCents)));
    },
    [amount, clearError]
  );

  return (
    <div className="space-y-3">
      <div
        className={`pix-transfer-amount-field ${error ? "pix-transfer-amount-field--error" : ""}`}
      >
        <span className="pix-transfer-amount-field__prefix">R$</span>
        <input
          type="text"
          value={amount}
          onChange={handleChange}
          inputMode="numeric"
          maxLength={14}
          placeholder="0,00"
          aria-label="Valor da transferência"
          aria-invalid={!!error}
          className="pix-transfer-amount-field__input"
        />
      </div>

      {error && <p className="text-xs text-red-600">{error}</p>}

      <div className="flex flex-wrap gap-2">
        {QUICK_AMOUNTS.map(({ key, label }) => (
          <button
            key={key}
            type="button"
            onClick={() => handleQuickAdd(key)}
            className="rounded-lg border border-gray-200 bg-white px-3 py-1.5 text-xs font-semibold text-gray-600 transition hover:border-[#e7a73f]/40 hover:bg-brand-cream hover:text-brand-dark"
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};
